export const GATEWAY_BASE = 'https://ai-gateway.will-i-bracken.workers.dev';

async function jsonFetch(path, opts = {}, timeoutMs = 60_000) {
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), timeoutMs);
  try {
    const res = await fetch(`${GATEWAY_BASE}${path}`, {
      ...opts,
      signal: ctrl.signal,
    });
    const text = await res.text();
    let data;
    try {
      data = text ? JSON.parse(text) : null;
    } catch {
      data = { raw: text };
    }
    if (!res.ok) {
      const err = new Error(data?.error || `HTTP ${res.status}`);
      err.status = res.status;
      err.body = data;
      throw err;
    }
    return data;
  } finally {
    clearTimeout(timer);
  }
}

export const api = {
  health: () => jsonFetch('/health', {}, 10_000),
  stats: () => jsonFetch('/stats', {}, 15_000),
  chat: (body) =>
    jsonFetch(
      '/chat',
      {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(body),
      },
      60_000
    ),
  search: (body) =>
    jsonFetch(
      '/search',
      {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(body),
      },
      30_000
    ),
  orchestrate: (body) =>
    jsonFetch(
      '/orchestrate',
      {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(body),
      },
      120_000
    ),
};

export function pollHealth(onTick, intervalMs = 30_000) {
  let stopped = false;
  let timer;
  async function tick() {
    if (stopped) return;
    try {
      const h = await api.health();
      onTick({ ok: true, data: h, at: Date.now() });
    } catch (e) {
      onTick({ ok: false, error: e?.message || String(e), at: Date.now() });
    }
    if (!stopped) timer = setTimeout(tick, intervalMs);
  }
  tick();
  return () => {
    stopped = true;
    if (timer) clearTimeout(timer);
  };
}
